import React from 'react'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import config from '../../config.json'
import SubmenuItem from '../general/SubmenuItem'

const PageMarketingPage = ({pageName, usedWebToPrintRoutes}) => {
    const routes = config.routes
    
    return (
        <WrapperPageSimple pageTitle={pageName} pageTitleTransId={config.routes.marketing.transId}>
            <div className="print-page print-type site-content">
                {usedWebToPrintRoutes[0] ? usedWebToPrintRoutes.map((routeKey) => {
                    const { name, transId, path } = routes[routeKey]

                    return <SubmenuItem 
                                key={routeKey} 
                                id={routeKey} 
                                name={name} 
                                transId={transId} 
                                path={path}
                            />
                        }
                    ) : (
                        <div>Bitte kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com">Support</a></div>
                    )
                }
            </div>
        </WrapperPageSimple>
    )
}

export default PageMarketingPage  